/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { tagName } from '@ember-decorators/component';
import { computed } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import { NAMES, SYNC_STATUSES } from 'cio/utils/ad-audiences';

@tagName('')
export default class AudienceIconWithStatus extends Component {
  @service moment;

  // external
  audience = null;

  // internal
  @computed('audience.{type,lastSynced,status}')
  get _tooltipContent() {
    let {
      audience: { type, lastSynced },
    } = this;

    let status = SYNC_STATUSES[this.audience.status.id];
    if (!status) {
      return '';
    }

    return status.explanation({ name: NAMES[type], time: this.moment.formatTimestamp([lastSynced], {}) });
  }
}
